require("./lightcase.js");

$(function () {
  $('a[rel="lightcase"]').lightcase({
    maxWidth: 1000,
    maxHeight: 1000,
    shrinkFactor: 0.95,
  });
});
